import { render, staticRenderFns } from "./custom-list.vue?vue&type=template&id=72730b9c"
import script from "./custom-list.vue?vue&type=script&lang=js"
export * from "./custom-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports